import { Reveal } from "@/components/site/Reveal";
import { whyUs } from "@/data/content";

export const WhyUs = () => (
  <section className="bg-card" data-testid="why-us-section">
    <div className="mx-auto max-w-7xl px-5 py-20 lg:px-10 lg:py-28">
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-6">
          <figure>
            <img
              src="./images/fasada-bily-dum.jpg"
              alt="Dokončená fasáda rodinného domu"
              className="h-[380px] w-full rounded-md object-cover lg:h-[540px]"
              loading="lazy"
            />
            <figcaption className="mt-2 text-xs text-muted-foreground">
              Fasáda rodinného domu · dokončená realizace
            </figcaption>
          </figure>
        </Reveal>
        <div className="lg:col-span-6 lg:pl-8">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-accent">
              Proč Goalstav
            </p>
            <h2 className="mt-3 font-serif-accent text-3xl font-medium tracking-tight text-foreground sm:text-4xl">
              Kvalita, na kterou se můžete spolehnout.
            </h2>
          </Reveal>
          <div className="mt-10 flex flex-col">
            {whyUs.map((item, i) => (
              <Reveal key={item.label} delay={i * 0.07}>
                <div className="border-t border-border py-6 first:border-t-0">
                  <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-foreground">
                    {item.label}
                  </h3>
                  <p className="mt-2 max-w-md text-sm leading-relaxed text-muted-foreground">
                    {item.text}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
